import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menu: true,
    imgSrc:
      "https://res.cloudinary.com/ajiva/image/upload/v1581707626/portfolio/Aji-plates-protraka.jpg",
    siteLoaded: false
  },
  mutations: {
    changeMenuState(state) {
      state.menu = !state.menu;
    },
    changeImgSrc(state, payload) {
      state.imgSrc = payload;
    },
		updateSiteLoaded(state,payload){
			state.siteLoaded = payload
		}
  },
  actions: {},
  modules: {}
  // getters:{
  // 	showMenuState(state){
  // 		return state.menu;
  // 	}
  // }
});
